var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSetting2Primary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/setting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4026 6.1463C12.1959 6.1463 11.7026 5.29297 12.3026 4.2463C12.6493 3.63963 12.4426 2.8663 11.8359 2.51963L10.6826 1.85963C10.1559 1.5463 9.47594 1.73297 9.1626 2.25963L9.08927 2.3863C8.48927 3.43297 7.5026 3.43297 6.89594 2.3863L6.8226 2.25963C6.5226 1.73297 5.8426 1.5463 5.31594 1.85963L4.1626 2.51963C3.55594 2.8663 3.34927 3.6463 3.69594 4.25297C4.3026 5.29297 3.80927 6.1463 2.6026 6.1463C1.90927 6.1463 1.33594 6.71297 1.33594 7.41297V8.5863C1.33594 9.27963 1.9026 9.85297 2.6026 9.85297C3.80927 9.85297 4.3026 10.7063 3.69594 11.753C3.34927 12.3596 3.55594 13.133 4.1626 13.4796L5.31594 14.1396C5.8426 14.453 6.5226 14.2663 6.83594 13.7396L6.90927 13.613C7.50927 12.5663 8.49594 12.5663 9.1026 13.613L9.17594 13.7396C9.48927 14.2663 10.1693 14.453 10.6959 14.1396L11.8493 13.4796C12.4559 13.133 12.6626 12.353 12.3159 11.753C11.7093 10.7063 12.2026 9.85297 13.4093 9.85297C14.1026 9.85297 14.6759 9.2863 14.6759 8.5863V7.41297C14.6693 6.71963 14.1026 6.1463 13.4026 6.1463ZM8.0026 10.1663C6.80927 10.1663 5.83594 9.19297 5.83594 7.99963C5.83594 6.8063 6.80927 5.83297 8.0026 5.83297C9.19594 5.83297 10.1693 6.8063 10.1693 7.99963C10.1693 9.19297 9.19594 10.1663 8.0026 10.1663Z",
    stroke: "#07506D",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetting2Primary);
export default __webpack_public_path__ + "static/media/ic-setting-2-primary.e7834a2c589809c0c8091fe1c83e039c.svg";
export { ForwardRef as ReactComponent };